import { Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import CircleExit from "../../assets/images/icon/CircleExit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import BottomNavigation from "@mui/material/BottomNavigation";
import CustomSwitch from "../button/CustomSwitch";
import { SearchId } from "../../services/SearchId";
import {
  SearchPetOwnerProfile,
  postUpdatePetOwnerProfile,
} from "../../services/Dogbook";
import { useNavigate, useLocation } from "react-router-dom";
import Paper from "@mui/material/Paper";
import { useLiff } from "react-liff";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ScrollDialog(props) {
  const [scroll, setScroll] = React.useState("paper");
  const { open, setOpen, value, onYes, onNo } = props;
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleYes = () => {
    setOpen(false);
    onYes(value);
  };

  const handleNo = () => {
    setOpen(false);
    onNo(value);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      {/* <Button onClick={handleClickOpen('paper')}>scroll=paper</Button> */}
      <Dialog
        open={open}
        onClose={handleClose}
        // scroll={scroll}
        fullWidth={true}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          <div className="flex justify-between">
            <div>
              {value == "cookie" ? (
                <p className="text-lightGreen text-[28px] text-left leading-[33.6px]">
                  นโยบายการใช้คุกกี้
                </p>
              ) : (
                <p className="text-lightGreen text-[28px] text-left leading-[33.6px]">
                  ประกาศนโยบายความเป็นส่วนตัว
                </p>
              )}
            </div>
            <div>
              <button onClick={handleClose}>
                <CircleExit />
              </button>
            </div>
          </div>
        </DialogTitle>
        <div className="bg-lightGray2 max-h-[400px] overflow-y-auto px-[15px] py-[15px]">
          {value === "cookie" ? <ContentCookie /> : <ContentTerm />}
        </div>

        <div style={{ marginTop: 52 }}>
          <Box>
            <Paper
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1,
              }}
              elevation={1}
            >
              <div
                className="w-full flex px-[20%]"
                style={{ gap: "12px", alignItems: "center", height: "52px" }}
              >
                <button
                  onClick={handleNo}
                  className="flex justify-center items-center border-[1px] border-green rounded-[28px] w-full gap-[10px] py-[4px]"
                >
                  <p className="text-[16px] text-green text-center">ไม่ยินยอม</p>
                </button>
                <button
                  onClick={handleYes}
                  className="flex justify-center items-center bg-green rounded-[28px] w-full gap-[10px] py-[4px]"
                >
                  <p className="text-[16px] text-white text-center">ยินยอม</p>
                </button>
              </div>
            </Paper>
          </Box>
        </div>
      </Dialog>
    </div>
  );
}

const ContentTerm = (props) => {
  const policies = [
    {
      text: "บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย) จํากัด\n(“บริษัทฯ”) มีความจำเป็นต้องเก็บรวบรวม ใช้ เปิดเผย โอน และประมวลผล\nข้อมูลส่วนบุคคลของท่าน ทั้งที่เป็นข้อมูลส่วนบุคคลทั่วไป (“ข้อมูลส่วน\nบุคคลทั่วไป”) และข้อมูลส่วนบุคคลที่ละเอียดอ่อน (“ข้อมูลส่วนบุคคล\nที่ละเอียดอ่อน”) (รวมเรียกว่า “ข้อมูลส่วนบุคคล”) ดังต่อไปนี้\n",
      type: "normal",
    },
    {
      text: "ข้อมูลส่วนบุคคลทั่วไป",
      type: "title",
    },
    {
      text: [
        "ชื่อและนามสกุล",
        "หมายเลขติดต่อ",
        "ที่อยู่อีเมลล์",
        "วันเดือนปีเกิด",
        "ที่อยู่",
        "ไอดีไลน์ (LINE ID)\n",
      ],
      type: "list-bullet",
    },
    {
      text: "วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล",
      type: "title",
    },
    {
      text: "บริษัทฯ จะเก็บรวบรวม ใช้ เปิดเผย โอน และประมวลผลข้อมูลส่วนบุคคล\nของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้",
      type: "normal",
    },
    {
      text: [
        "การก่อตั้ง พัฒนา จัดการ ดำรงไว้ เก็บรักษา หรือเข้าตกลงในเรื่อง\nการสิ้นสุดซึ่งความสัมพันธ์ทางธุรกิจระหว่างท่านกับบริษัทฯ",
        "การดำเนินกิจกรรมทางการขาย การตลาด และ ทางการแพทย์\nทั้งในรูปแบบพบปะและแบบดิจิตอล เมื่อกิจกรรมนั้นได้ผ่านการรับรอง\nแล้ว",
        "การจัดเตรียม หรือบริหารจัดการด้านลอจิสติกส์สำหรับกิจกรรม\nที่เกี่ยวข้องกับบริษัทฯ",
        "การดำเนินการรับรองลูกค้า",
        "การบริหารจัดการบัญชีลูกค้า",
        "การตรวจสอบและรายงานการเฝ้าระวังความปลอดภัยจากการใช้ยา",
        "การรายงานตามกฎระเบียบภายในของบริษัทฯ",
        "การจัดเตรียม ดำเนินการ หรือบริหารจัดการโครงการการตลาด เช่น\nการโฆษณาสินค้าและผลิตภัณฑ์ (Advertising Product) การสร้าง\nแบรนด์และทำให้เข้าใจรับรู้ในเรื่องโรคภัยต่าง ๆ  (Building Brand\nand Disease Awareness)",
        "การจัดหาและให้บริการข้อมูลสินค้า",
        "การจัดหาและให้บริการข้อมูลสินค้า",
        "การจัดส่งข้อมูลให้แก่ท่านซึ่งเกี่ยวกับสินค้าของบริษัทฯ การศึกษา\nทางการแพทย์ สื่อและเอกสารส่งเสริมการขาย  ข้อมูลที่เกี่ยวข้อง\nกับการเฝ้าระวังความปลอดภัยจากการใช้ยา\n(pharmacovigilance-related information) โครงการพัฒนา\nข้อมูลวิชาชีพอย่างต่อเนื่อง การประชุม และข้อมูลทางการเงิน\nและสัญญาที่บริษัทฯ เห็นว่าท่านอาจให้ความสนใจ\n",
      ],
      type: "list-bullet",
    },
    {
      text: "ความจำเป็นในการประมวลผลข้อมูลส่วนบุคคล",
      type: "title",
    },
    {
      text: "บริษัทฯ  จำเป็นต้องได้รับข้อมูลส่วนบุคคลของท่านเพื่อดำเนินการตาม\nวัตถุประสงค์ดังกล่าวข้างต้น\n",
      type: "normal",
    },
    {
      text: "ผลกระทบหากบริษัทฯ ไม่ได้รับข้อมูลส่วนบุคคลของท่าน",
      type: "title",
    },
    {
      text: "บริษัทฯ จะไม่สามารถดำเนินการใดๆเพื่อให้บรรลุวัตถุประสงค์ตามที่กล่าว\nมาได้ หากบริษัทไม่ได้รับข้อมูลส่วนบุคคลข้างต้น\n",
      type: "normal",
    },
    {
      text: "การเปิดเผยหรือโอนข้อมูลส่วนบุคคล",
      type: "title",
    },
    {
      text: "บริษัทฯจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นความลับอย่าง\nเคร่งครัดและจะไม่เปิดเผยหรือโอนข้อมูลดังกล่าวให้บุคคลภายนอก เว้นแต่\nบริษัทฯ จะได้รับความยินยอมโดยชัดแจ้งจากท่านหรือได้รับคำสั่งจากเจ้า\nหน้าที่ผู้มีอำนาจ\n{5}เพื่อวัตถุประสงค์ดังกล่าวข้างต้น บริษัทฯ จะเปิดเผยและ/หรือโอนข้อมูล\nส่วนบุคคลของท่านให้แก่บุคคลภายนอกซึ่งรวมถึง",
      type: "normal",
    },
    {
      text: [
        "บริษัทแม่ บริษัทในเครือ และบริษัทในกลุ่มของบริษัทฯ",
        "คู่ค้าหรือพันธมิตรทางธุรกิจ ผู้ให้บริการ ซัพพลายเออร์\nหรือผู้จำหน่ายสินค้าที่ได้รับอนุญาต",
        "ธนาคารพาณิชย์",
        "หน่วยงานหรือเจ้าหน้าที่ของรัฐบาล",
      ],
      type: "list-bullet",
    },
    {
      text: "{5}ในกรณีที่ต้องมีการโอนข้อมูลส่วนบุคคลออกนอกประเทศไทย บริษัทฯ\nจะดำเนินการโดยเป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล\nพ.ศ. 2562 (“พรบ. คุ้มครองข้อมูลส่วนบุคคล”) ซึ่งรวมถึงแต่ไม่จำกัดเพียง\nกฎกระทรวง ประกาศ การตีความ หรือกฎระเบียบอื่น ๆ ที่ออกภายใต้พรบ.\nคุ้มครองข้อมูลส่วนบุคคล\n",
      type: "normal",
    },
    {
      text: "ระยะเวลาการเก็บรักษาข้อมูล",
      type: "title",
    },
    {
      text: "บริษัทฯ มีนโยบายในการเก็บรักษาข้อมูลส่วนบุคคลของท่าน ตามระยะเวลา\nที่กำหนดไว้ ทั้งในรูปแบบกระดาษหรืออิเล็กทรอนิกส์ บริษัทฯ จะไม่เก็บ\nรักษาข้อมูลส่วนบุคคลของคุณเมื่อไม่จำเป็นต้องใช้เพื่อวัตถุประสงค์ทาง\nธุรกิจหรือกฎหมายอีกต่อไป หากท่านถอนคำยินยอมของท่านที่ให้บริษัทฯ\nขอลบบัญชีผู้ใช้ หรือคัดค้านการประมวลผลข้อมูล บริษัทฯ จะลบข้อมูล\nของท่าน ที่ได้รวบรวมไว้ภายในระยะเวลาที่เหมาะสม\n{5}บริษัทฯ  ขอรับรองว่าข้อมูลส่วนบุคคลของท่านจะได้รับการเก็บรักษาไว้ใน\nสถานที่ที่ปลอดภัย ซึ่งเฉพาะผู้ได้รับอนุญาตเท่านั้นที่จะสามารถเข้าถึง\nข้อมูลนั้นได้ และบริษัทฯ จะทำลายข้อมูลส่วนบุคคลของท่านเป็นการถาวร\nทันทีที่สิ้นสุดระยะเวลาเก็บรักษาข้อมูล เว้นแต่กฎหมายจะกำหนดให้บริษัทฯ\nต้องเก็บรักษาข้อมูลเป็นเวลานานกว่านั้น ซึ่งบริษัทฯ จะได้แจ้งให้ท่านทราบ\nโดยทันที\n",
      type: "normal",
    },
    {
      text: "สิทธิ์ของท่านเกี่ยวกับข้อมูลส่วนบุคลภายใต้พรบ.คุ้มครอง\nข้อมูลส่วนบุคคล",
      type: "title",
    },
    {
      text: "ภายใต้การคุ้มครองข้อมูลส่วนบุคคลของท่านนั้น บริษัทฯ มีการดำเนิน\nการอย่างเคร่งครัดและจริงจัง ภายใต้นโยบายและมาตรการในการคุ้มครอง\nข้อมูลส่วนบุคคล เพื่อให้เป็นไปตามพรบ. คุ้มครองข้อมูลส่วนบุคคล\nและกฎหมายอื่น ๆ ที่เกี่ยวข้อง\n{5}ท่านมีสิทธิ์ทุกประการตามที่พรบ. คุ้มครองข้อมูลส่วนบุคคลได้กำหนดไว้\nเว้นแต่ในบางสถานการณ์ที่บริษัทฯ อาจจำเป็นต้องปฏิเสธคำขอใช้สิทธิ์\nของท่าน\n{5}และที่สำคัญคือท่านมีสิทธิ์ที่จะถอนความยินยอมของท่านที่ให้บริษัทฯ\nเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านได้ไม่ว่าจะในเวลาใด\nก็ตาม ทั้งนี้ หากท่านมีความประสงค์ให้บริษัทฯ ทำการเปลี่ยนแปลงใด ๆ \nเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของท่าน ท่านสามารถแจ้ง\nให้บริษัทฯ ทราบได้ทุกเวลา",
      type: "normal",
    },
    {
      text: [
        "ท่านสามารถศึกษารายละเอียดเพิ่มเกี่ยวกับสิทธิ์ของท่านและขั้นตอนการ\nขอถอนความยินยอมได้จากนโยบายความเป็นส่วนตัวของบริษัทฯ\nที่ปรากฏบนเว็บไซต์",
        "https://www.boehringerone.com/th/privacy",
      ],
      type: "normal-link",
    },
    {
      text: "ติดต่อเรา",
      type: "title",
    },
    {
      text: "หากท่านมีข้อสงสัยใด ๆ เกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของท่าน\nโดยบริษัทฯ หรือประสงค์จะขอข้อมูลเพิ่มเติม หรือใช้สิทธิ์ใด ๆ ของท่าน\nท่านสามารถติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection\nOfficer) ของบริษัทฯ โดยตรงตามรายละเอียดดังต่อไปนี้",
      type: "normal",
    },
    {
      text: "เบอริงเกอร์ อินเกลไฮม์ ประเทศไทย",
      type: "normal-bold",
    },
    {
      text: "เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer)",
      type: "normal-small",
    },
    {
      text: ["เบอร์ติดต่อ:", "+66 2 308-8522"],
      type: "normal-tel",
    },
    {
      text: ["อีเมลล์:", "zzLEGCompDPOThailand@boehringer-ingelheim.com"],
      type: "normal-email",
    },
    {
      text: "นอกจากนี้ ท่านยังสามารถติดต่อกับตัวแทนของบริษัทฯ ได้",
      type: "normal",
    },
  ];
  return (
    <>
      {policies.map((item) => {
        return (
          <div>
            {item.type == "normal" ? (
              <p className="text-[16px] text-darkGray leading-[1.2] mb-[10px]">
                {item.text}
              </p>
            ) : item.type == "title" ? (
              <p className="text-[20px] text-lightGreen leading-[1.2] mb-[4px]">
                {item.text}
              </p>
            ) : item.type == "list-bullet" ? (
              <ul className="ml-[27px] list-disc mb-[15px]">
                {item.text.map((t) => (
                  <li>
                    <p className="text-[16px] text-darkGray leading-[1.2]">
                      {t}
                    </p>
                  </li>
                ))}
              </ul>
            ) : (
              <></>
            )}
          </div>
        );
      })}
    </>
  );
};

const ContentCookie = (props) => {
  const cookies = [
    {
      text: [
        'บททั่วไป LINE @oneanddonefordogs ดำเนินการโดยบริษัท เบอริงเกอร์\nอินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย) จำกัด ตั้งอยู่ เลขที่\n2922/193-195 อาคารชาญอิสสระทาวเวอร์ 2 ชั้น 9 ถนนเพชรบุรี\nตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310\n ซึ่งต่อไปในนโยบายการใช้คุกกี้ฉบับนี้ ต่อจากนี้เรียกว่า "ทางเรา"\nหรือ "เรา" เรามุ่งมั่นที่จะปกป้องและเคารพความเป็นส่วนตัวของท่าน\nกรุณาอ่านนโยบายการใช้คุกกี้ฉบับนี้พร้อมกับนโยบายความเป็น\n ส่วนตัวและเงื่อนไขการใช้งานของเรา ซึ่งมีการอธิบายว่าคุกกี้คืออะไร\nทำไมเราถึงใช้คุกกี้และใช้อย่างไร เมื่อท่านเข้าเยี่ยมชมเว็บไซต์ และท่าน\nสามารถบล็อก และ/หรือลบคุกกี้ได้อย่างไร',
        "ความยินยอม เว็บไซต์ของเราใช้คุกกี้เพื่อจำแนกท่านออกจากผู้ใช้งาน\nรายอื่นของเว็บไซต์ ซึ่งช่วยให้เราสามารถมอบประสบการณ์ที่ดี\nให้แก่ท่านในขณะท่องเว็บไซต์ และยังช่วยให้เราสามารถปรับปรุงเว็บ\nไซต์ให้ดียิ่งขึ้นได้ด้วย เมื่อท่านยังท่องเว็บไซต์ต่อไปแสดงว่าท่าน\nยอมรับการใช้คุกกี้ของเรา",
        "คุกกี้คืออะไร คุกกี้เป็นไฟล์ข้อความที่ประกอบด้วยข้อมูลจำนวน\nไม่มาก ซึ่งโดยปกติจะเป็นสตริงอักขระและตัวเลขต่างๆ และถูกนำไปใช้\nทั่วอินเทอร์เน็ตและจัดเก็บไว้ในและเข้าถึงได้จากอุปกรณ์ของท่านใน\nขณะเข้าเยี่ยมชมเว็บไซต์ (รวมถึงเว็บไซต์นี้)",
        "เว็บไซต์นี้ใช้คุกกี้อย่างไร คุกกี้ดังกล่าวนี้ช่วยปรับปรุงเว็บไซต์นี้ทาง\nอ้อม โดยการติดตามการใช้งานของท่าน คุกกี้ชุดนี้รวบรวมข้อมูล\nและอาจรายงานสถิติการใช้งานเว็บไซต์โดยไม่ได้ระบุตัวตนของผู้เข้า\nชมเว็บไซต์แต่ละราย",
        "เราใช้คุกกี้ประเภทใดบ้าง?",
      ],
      type: "list-number",
    },
    {
      text: [
        "คุกกี้การนำทางหรือคุกกี้แบบช่วงเวลา – เป็นคุกกี้ชั่วคราว\nที่ยังคงใช้งานได้จนกว่าท่านจะออกจากระบบเว็บไซต์\nหรือคุกกี้หมดอายุเนื่องจากไม่มีการใช้งานเป็นระยะเวลาหนึ่ง\nคุกกี้แบบช่วงเวลาจำเป็นต่อเว็บไซต์เพื่อให้ทำงานได้อย่างถูก\nต้อง เช่น การเข้าถึงบริเวณสำหรับเข้าสู่ระบบของเว็บไซต์\nซึ่งจำเป็นสำหรับการท่องและใช้เว็บไซต์ทั่วไป เราอาจใช้คุกกี้\nที่มีระยะเวลาเท่ากับช่วงเวลาการท่องเว็บหนึ่งครั้ง ซึ่งจะหมด\nอายุเมื่อปิดเบราว์เซอร์ หรือเราสามารถใช้คุกกี้แบบถาวร\nซึ่งใช้งานได้นานกว่านั้นแม้ว่าจะปิดเบราว์เซอร์ไปแล้วก็ตาม\nแต่มักจะเป็นช่วงเวลาที่มีการกำหนดไว้โดยเฉพาะเสมอ",
        "คุกกี้เพื่อการวิเคราะห์/วัดผลการทำงานของเว็บไซต์ - ใช้เพื่อ\nรวบรวมข้อมูลโดยรวมเกี่ยวกับจำนวนผู้ใช้งานและวิธีการที่ผู้ใช้\nงานเข้าเยี่ยมชมเว็บไซต์ ซึ่งทำให้เรารับทราบ และนับจำนวน\nผู้เข้าชมเว็บไซต์และดูว่าผู้เข้าชมเว็บไซต์ท่องเว็บไซต์ของเรา\nอย่างไรบ้างเมื่อพวกเขาใช้งาน ส่วนนี้ช่วยให้เราสามารถ\nปรับปรุงวิธีการทำงานของเว็บไซต์ให้ดียิ่งขึ้นได้ ตัวอย่างเช่น\nรับรองว่าผู้ใช้งานสามารถค้นหาสิ่งที่ต้องการได้อย่างง่ายดาย",
        "คุกกี้เพื่อการทำงานของเว็บไซต์ - คุกกี้ประเภทนี้ทำให้ผู้ใช้งาน\nสามารถท่องเว็บไซต์ได้ตามเกณฑ์ที่เลือก (เช่น ภาษา\nผลิตภัณฑ์ที่เลือกซื้อ) เพื่อสร้างประสบการณ์ในการใช้งาน\nเว็บไซต์ของท่านให้ดียิ่งขึ้น คุกกี้นี้ถูกนำมาใช้เพื่อจดจำ เมื่อท่าน\nกลับมาเยี่ยมชมเว็บไซต์ของเราอีกครั้ง เราสามารถปรับเปลี่ยน\nเนื้อหาของเราให้เหมาะสมกับท่านและจดจำการตั้งค่าของท่านได้\n(ตัวอย่างเช่น การเลือกภาษาหรือภูมิภาคของท่าน)",
        "คุกกี้เพื่อปรับเนื้อหาเข้ากับกลุ่มเป้าหมาย - คุกกี้นี้จะบันทึก\nการเข้าเยี่ยมชมเว็บไซต์ของเรา หน้าเว็บที่ท่านเข้าเยี่ยมชม\nและลิงก์ที่ท่านติดตาม เราจะใช้ข้อมูลนี้เพื่อทำให้เว็บไซต์ของเรา\nและโฆษณาที่ปรากฏบนเว็บไซต์มีความเกี่ยวข้องกับความสนใจ\nของท่านมากขึ้น เราอาจแบ่งปันข้อมูลนี้กับบุคคลภายนอกเพื่อ\nวัตถุประสงค์นี้ด้วย",
        "คุกกี้แบบถาวร คุกกี้นี้จะยังคงอยู่ในอุปกรณ์ของท่านเป็นระยะ\nเวลาที่นานขึ้น (ระยะเวลาขึ้นอยู่กับอายุของคุกกี้โดยเฉพาะ)\nเว็บไซต์อาจใช้คุกกี้แบบถาวรสองตัวซึ่ง",
      ],
      type: "list-bullet",
    },
    {
      text: [
        "อาจถูกเก็บไว้ในอุปกรณ์ของท่านหลังจากที่ท่านเข้าสู่\nเว็บไซต์ครั้งแรก คุกกี้นี้ระบุลักษณะเฉพาะของบริษัทที่ไม่\nซ้ำกัน และนำมาใช้เพื่อจัดทำการสร้างตัวตนของเว็บไซต์\nและการปรับแต่งอื่น ๆ",
        "อาจถูกเก็บไว้ในอุปกรณ์ของท่าน หากท่านเลือกให้\nเว็บไซต์จดจำชื่อผู้ใช้ของท่าน โดยสามารถเลือกตัวเลือก\nนี้ได้โดยเลือกทำเครื่องหมายที่ช่องในหน้าลงชื่อเข้าใช้\nของสมาชิก เมื่อเลือกทำเครื่องหมายที่ช่องแล้วแสดงว่า\nท่านยินยอมให้เราจัดเก็บและอ่านคุกกี้นี้",
      ],
      type: "list-sub-bullet",
    },
    {
      text: [
        "เว็บบีคอน - เป็นภาพกราฟิกขนาดเล็กที่มีความโปร่งใส\nข้อมูลนี้ถูกนำไปใช้ในการจัดทำรายงานเพื่อช่วยให้เราสามารถ\nปรับปรุงการบริการของเราให้ดียิ่งขึ้นให้แก่ท่านได้",
      ],
      type: "list-bullet",
    },
    {
      text: [
        "บุคคลภายนอก บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์\n(ประเทศไทย) จำกัด อาจฝังวิดีโอหรือเนื้อหาอื่น ๆ ลงในเว็บไซต์\nและเมื่อท่านเข้าเยี่ยมชมหน้าเว็บที่มีเนื้อหาฝังอยู่ ท่านอาจได้รับคุกกี้\nจากเนื้อหานั้น  บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์\n(ประเทศไทย) จำกัด ไม่ได้ควบคุมคุกกี้ดังกล่าวนี้ และเราขอแนะนำ\nให้ท่านตรวจสอบเว็บไซต์ของบุคคลภายนอกสำหรับข้อมูลเกี่ยวกับ\nพวกเขา\n{5}วิดีโอที่ฝังอยู่ในเว็บไซต์จะไม่ได้เล่นเองโดยอัตโนมัติ เมื่อคลิกที่ปุ่ม\nเล่นสำหรับวิดีโอที่ฝังอยู่ใด ๆ ก็ตาม แสดงว่าท่านยินยอมให้จัดเก็บ\nคุกกี้แฟลช (ถ้ามี) ไว้ในอุปกรณ์ของท่านได้",
      ],
      type: "list-number",
    },
    {
      text: [
        "ฉันจะบล็อกและ/หรือลบคุกกี้ได้อย่างไร? ท่านสามารถบล็อกการ\nใช้คุกกี้หรือลบคุกกี้ที่ติดตั้งไว้แล้วในเบราว์เซอร์ของท่านได้\n{5}เราขอแจ้งให้ท่านทราบข้อเท็จจริงว่าการปิดใช้งานคุกกี้อาจทำให้ท่าน\nไม่สามารถเข้าถึงคุณสมบัติบางอย่างบนเว็บไซต์ของเรา และเว็บไซต์\nอื่นๆ ได้\n{5}ท่านสามารถตั้งค่าเบราว์เซอร์ให้ยอมรับหรือปฏิเสธคุกกี้ทั้งหมด\nให้แจ้งเตือนเมื่อมีการใช้คุกกี้ ให้ตรวจสอบความถูกต้อง ระยะเวลา\nเนื้อหา และให้ลบคุกกี้ตามระยะเวลาที่กำหนดได้ นอกจากนี้ท่านยัง\nสามารถพิมพ์คำว่า “คุกกี้” ลงในส่วนช่วยเหลือของเบราว์เซอร์เพื่อดู\nคำแนะนำเกี่ยวกับการตั้งค่าได้ สำหรับข้อมูลเกี่ยวกับวิธีจัดการคุกกี้\nในเบราว์เซอร์ของอุปกรณ์มือถือของท่าน โดยจะต้องศึกษาคู่มือของ\nอุปกรณ์ดังกล่าว",
      ],
      type: "list-number",
    },
    {
      text: [
        "การติดต่อเรา บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์\n(ประเทศไทย) จำกัด ขอสงวนสิทธิ์ในการเปลี่ยนแปลงนโยบายการใช้\nคุกกี้ฉบับนี้เมื่อใดก็ได้ โดยแจ้งให้ทราบผ่านการโพสต์เกี่ยวกับการ\nเปลี่ยนแปลงในเว็บไซต์นี้  กรุณาตรวจสอบหน้าเว็บนี้เป็นประจำเพื่อ\nดูการเปลี่ยนแปลงใด ๆ  นโยบายฉบับนี้ได้รับการปรับปรุงล่าสุด\nเมื่อวันที่  25 มิถุนายน พ.ศ. 2563\n{5}หากมีข้อสงสัยเกี่ยวกับแนวปฏิบัติการใช้คุกกี้ของเรา ท่านสามารถ\nติดต่อเราได้ทุกเมื่อ หรือสามารถติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วน\nบุคคลของเราได้โดยตรง:",
      ],
      type: "list-number",
    },
    {
      text: "เบอริงเกอร์ อินเกลไฮม์ ประเทศไทย",
      type: "normal-bold",
    },
    {
      text: "เจ้าหน้าที่คุ้มครองข้อมูล",
      type: "normal-small",
    },
    {
      text: ["หมายเลขโทรศัพท์ติดต่อ:", "+66 2 308-8522"],
      type: "normal-tel",
    },
    {
      text: ["อีเมล:", "zzLEGCompDPOThailand@boehringer-ingelheim.com"],
      type: "normal-email",
    },
    {
      text: "คำชี้แจงสิทธิ์การเข้าถึง",
      type: "title",
    },
    {
      text: "เบอริงเกอร์ อินเกลไฮม์  มุ่งมั่นที่จะให้บริการเว็บไซต์ที่สามารถเข้าถึงผู้ชม\nได้มากที่สุด โดยไม่คำนึงถึงเทคโนโลยีหรือศักยภาพ เรามุ่งมั่นทำงานอย่าง\nแข็งขันเพื่อเพิ่มสิทธิ์การเข้าถึงและความสามารถในการใช้งานเว็บไซต์ของ\nเรา และเพื่อให้เป็นไปตามมาตรฐานและแนวทางที่มีอยู่หลากหลาย ซึ่งแนว\nทางดังกล่าวนี้อธิบายถึงวิธีการที่ทำให้คนพิการสามารถเข้าถึงเนื้อหา\nเว็บไซต์ได้ง่ายขึ้น การปฏิบัติตามแนวทางดังกล่าวนี้จะช่วยให้ผู้ใช้งานทุกคน\nสามารถใช้งานเว็บไซต์ได้ง่ายขึ้น เราพยายามหาวิธีแก้ไขปัญหาอย่าง\nต่อเนื่อง ซึ่งจะช่วยทำให้สามารถเข้าถึงทุกส่วนของเว็บไซต์โดยรวมได้ใน\nระดับเดียวกัน",
      type: "normal",
    },
    {
      text: "องค์ประกอบมัลติมีเดีย: รูปภาพ ไฟล์วิดีโอ และไฟล์เสียง",
      type: "title",
    },
    {
      text: "ข้อความในไฟล์ ภาพ และข้อความอธิบายรูปภาพสั้น ๆ มีอยู่ในเนื้อหา\nมัลติมีเดีย และเนื้อหาที่ไม่ใช่ข้อความทั้งหมด  นอกจากนี้ยังมีเว็บไซต์\nรูปแบบย่อที่แสดงหน้าเว็บ พร้อมข้อความอธิบายแทนรูปภาพ และวิดีโอ\nทั้งหมด มีการระบุขนาดของวิดีโอ  และมัลติมีเดียทั้งหมดเพื่อให้สามารถ\nประมาณการเวลาดาวน์โหลดได้ หากจำเป็นต้องใช้ซอฟต์แวร์เพื่อดูวิดีโอ\nจะมีการโพสต์ลิงค์ดาวน์โหลด เสริมเอาไว้ วิดีโอทั้งหมดจะถูกนำเสนอด้วย\nซอฟต์แวร์เครื่องเล่น ซึ่งช่วย ให้ผู้ใช้งานสามารถเล่นวิดีโอ หยุดชั่วคราว\nหยุดเล่น เล่นเดินหน้า และเล่น ย้อนกลับได้",
      type: "normal",
    },
    {
      text: "การนำเสนอเนื้อหาและเค้าโครง",
      type: "title",
    },
    {
      text: "มีการแยกเนื้อหาและเค้าโครงอย่างเคร่งครัดผ่านการใช้ HTML และ CSS\n(Cascading Style Sheet) อย่างเหมาะสม หลีกเลี่ยงการใช้เค้าโครงแบบ\nตารางหากเป็นไปได้\n{5}เราพยายามนำเสนอโครงสร้างการนำทางเว็บไซต์ ที่ชัดเจน ซึ่งช่วยให้\nสามารถค้นหาเนื้อหาที่ท่านกำลังมองหาด้วยวิธีที่ง่ายและรวดเร็ว\nลิงค์ประกอบด้วยคำอธิบายหัวเรื่อง ซึ่งอธิบายเนื้อหา และทำให้เข้าใจได้ง่าย\nจากบริบท การใช้ประโยคและย่อหน้าสั้นๆ และจุดเริ่มต้นหลายจุดไปยังแหล่ง\nข้อมูลเพิ่มเติม เช่น  ผ่านองค์ประกอบทีเซอร์และบริเวณเนื้อหาที่เกี่ยวข้อง\nจะช่วยให้เข้าใจเนื้อหาได้ง่ายขึ้นในขณะเดียวกัน หากท่านประสบปัญหา\nในการเข้าถึงเว็บไซต์นี้ กรุณาติดต่อเราทันที\n{5}บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย) จำกัด\nไม่รับรองหรือรับประกันเกี่ยวกับความถูกต้องหรือความครบถ้วนของ\nข้อมูลใด ๆ ที่อยู่ในเว็บไซต์นี้  ภายใต้เงื่อนไขที่ทำให้ท่านสามารถเข้าถึงข้อมูล\nในเว็บไซต์นี้ได้โดยไม่เสียค่าใช้จ่าย ซึ่งบริษัท เบอริงเกอร์ อินเกลไฮม์\nแอนิมอล เฮลท์ (ประเทศไทย) จำกัด ไม่และจะไม่รับผิดชอบต่อความสูญเสีย\nการบาดเจ็บ หรือความเสียหายใด ๆ รวมถึงแต่ไม่จำกัดเพียงความสูญเสีย\nหรือความเสียหายโดยตรง โดยอ้อม พิเศษ เชิงลงโทษ โดยบังเอิญหรือสืบ\nเนื่อง กำไรที่สูญเสีย หรือความเสียหายที่เกิดขึ้นจากข้อมูลที่สูญหาย\nหรือการหยุดชะงักทางธุรกิจอันเป็นผลมาจากการเข้าใช้งานเว็บไซต์นี้หรือ\nการไม่สามารถเข้าใช้งานเว็บไซต์นี้ของผู้ใช้งาน หรือเพื่อการพึ่งพาข้อมูลใด ๆ\nที่มีอยู่ในเว็บไซต์นี้ของผู้ใช้งาน\n{5}บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย) จำกัด\nไม่ได้ยกเว้นความรับผิดต่อการเสียชีวิตหรือการบาดเจ็บของบุคคลที่เกิด\nขึ้นโดยตรงจากความประมาทเลินเล่อหรือการประพฤติมิชอบโดยเจตนา\nบริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย) จำกัด\nขอสงวนสิทธิ์ในการเพิ่ม ลบ หรือแก้ไขข้อมูลในเว็บไซต์นี้เมื่อใดก็ได้ และไม่\nต้องแจ้งให้ทราบล่วงหน้า ข้อยกเว้นและข้อจำกัดข้างต้นนำไปใช้กับขอบเขต\nตามที่กฎหมายอนุญาตเท่านั้น สิทธิ์ตามกฎหมายของท่านในฐานะผู้บริโภค\nต้องไม่ได้รับผลกระทบใด ๆ เว็บไซต์นี้มีข้อมูลเกี่ยวกับผลิตภัณฑ์ที่ได้รับ\nการอนุมัติให้ใช้ภายในประเทศไทยได้ในปัจจุบัน และอาจแนะนำให้ใช้โดยหรือ\nตามคำแนะนำของสัตวแพทย์ที่ได้รับอนุญาตเท่านั้น นอกจากนี้ เว็บไซต์นี้\nอาจมีข้อมูลเกี่ยวกับผลิตภัณฑ์ใหม่ที่ยังไม่ได้รับการอนุมัติในประเทศไทย\nในปัจจุบันหรือผลิตภัณฑ์ที่มีอยู่ในประเทศอื่น ซึ่งไม่ควรตีความว่าเป็นการ\nอนุญาตให้ใช้ผลิตภัณฑ์ดังกล่าวได้\n{5}เว็บไซต์นี้เชื่อมโยงไปยังเว็บไซต์อื่น ๆ ที่จัดทำโดยหน่วยงานต่าง ๆ ซึ่งบาง\nแห่งอาจตั้งอยู่นอกประเทศไทย  บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล\nเฮลท์ (ประเทศไทย) จำกัด จัดทำลิงค์เชื่อมโยงดังกล่าวนี้ เพื่ออำนวยความ\nสะดวกเท่านั้นและไม่รับรองความถูกต้องหรือความสมบูรณ์ของข้อมูลที่อยู่\nในนั้น เว็บไซต์ดังกล่าวอาจมีข้อมูลที่เหมาะสมเฉพาะกับประเทศหรือภูมิภาค\nต้นทางที่เป็นที่ตั้งของเว็บไซต์เท่านั้น\n{5}ท่านไม่ควรตีความสิ่งใดบนเว็บไซต์นี้ว่าเป็นการส่งเสริมหรือการชักชวนให้\nใช้ผลิตภัณฑ์ใด ๆ หรือเพื่อการใช้ผลิตภัณฑ์ใด ๆ ที่ไม่ได้รับอนุญาตตาม\nกฎหมายและข้อบังคับของประเทศที่ท่านอาศัยอยู่\n{5}ชื่อผลิตภัณฑ์ทั้งหมดที่ระบุไว้ในเว็บไซต์นี้ที่เป็นตัวอักษรตัวใหญ่และ/\nหรือตามด้วยสัญลักษณ์ ™ หรือ ® ถือเป็นเครื่องหมายการค้าของบริษัท\nเบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย) จำกัด เว้นแต่จะระบุไว้\nเป็นอื่น ไม่มีสิ่งใดในเว็บไซต์นี้ที่ถือว่าเป็นการให้อนุญาตหรือให้สิทธิ์ภายใต้\nลิขสิทธิ์ สิทธิ์บัตร เครื่องหมายการค้า หรือสิทธิ์ในทรัพย์สินทางปัญญา\nอื่น ๆ ของ บริษัท เบอริงเกอร์ อินเกลไฮม์ แอนิมอล เฮลท์ (ประเทศไทย)\nจำกัด หรือบุคคลภายนอก",
      type: "normal",
    },
  ];
  return (
    <>
      {cookies.map((item) => {
        return (
          <div>
            {item.type == "normal" ? (
              <p className="text-[16px] text-darkGray leading-[1.2] mb-[10px]">
                {item.text}
              </p>
            ) : item.type == "title" ? (
              <p className="text-[20px] text-lightGreen leading-[1.2] mb-[4px]">
                {item.text}
              </p>
            ) : item.type == "list-bullet" ? (
              <ul className="ml-[27px] list-disc mb-[15px]">
                {item.text.map((t) => (
                  <li>
                    <p className="text-[16px] text-darkGray leading-[1.2]">
                      {t}
                    </p>
                  </li>
                ))}
              </ul>
            ) : item.type == "list-number" ? (
              <ul className="ml-[10px] list-decimal mb-[15px]">
                {item.text.map((t) => (
                  <li>
                    <p className="text-[16px] text-darkGray leading-[1.2]">
                      {t}
                    </p>
                  </li>
                ))}
              </ul>
            ) : item.type == "normal-bold" ? (
              <p
                className="text-[16px] font-medium text-darkGray leading-[1.2]  mb-[0px]"
                style={{ color: "#000" }}
              >
                {item.text}
              </p>
            ) : item.type == "normal-small" ? (
              <p className="text-[14px] text-darkGray leading-[1.2] mb-[0px]">
                {item.text}
              </p>
            ) : item.type == "normal-tel" ? (
              <div className="flex">
                <p className="text-[14px] text-darkGray leading-[1.2] mb-[0px]">
                  {item.text[0]}
                </p>
                &nbsp;
                <p className="text-[14px] text-darkGray leading-[1.2] mb-[0px]">
                  <a
                    className="text-green leading-[0]"
                    href={`tel:${item.text[1]}`}
                  >
                    {item.text[1]}
                  </a>
                </p>
              </div>
            ) : item.type == "normal-email" ? (
              <div className="flex">
                <p className="text-[14px] text-darkGray leading-[1.2] mb-[0px]">
                  {item.text[0]}
                </p>
                &nbsp;
                <p className="text-[14px] text-darkGray leading-[1.2] mb-[0px]">
                  <a
                    className="text-green leading-[0]"
                    href={`mailto:${item.text[1]}`}
                  >
                    {item.text[1]}
                  </a>
                </p>
              </div>
            ) : item.type == "list-sub-bullet" ? (
              <ul className="ml-[37px] list-lower-roman mb-[15px]">
                {item.text.map((t) => (
                  <li>
                    <p className="text-[16px] text-darkGray leading-[1.2]">
                      {t}
                    </p>
                  </li>
                ))}
              </ul>
            ) : (
              <>{item.type}</>
            )}
          </div>
        );
      })}
    </>
  );
};
